<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="添加计划"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="所属项目：" prop="projectId">
          <el-select
            size="mini"
            v-model="form.projectId"
            filterable
            placeholder="请选择所属项目"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchProjectList"
            @visible-change="searchProjectList('')"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.projectName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电梯：" prop="liftId" class="mr0">
          <el-select
            size="mini"
            v-model="form.liftId"
            filterable
            placeholder="请选择电梯"
            clearable
            reserve-keyword
            :remote="true"
            :remote-method="searchLiftList"
            @visible-change="searchLiftList('')"
          >
            <el-option
              v-for="item in liftList"
              :key="item.liftId"
              :label="item.liftLocation"
              :value="item.liftId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维保类型：" prop="maintainType">
          <el-select
            size="mini"
            v-model="form.maintainType"
            filterable
            placeholder="请选择维保类型"
            clearable
            reserve-keyword
          >
            <el-option
              v-for="item in maintainTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划时间：" class="mr0" prop="planTime">
					<el-date-picker
						v-model="form.planTime"
						size="mini"
						type="date"
						placeholder="请选择计划时间"
						value-format="yyyy-MM-dd"
						unlink-panels
						prefix-icon=" "
						clearable
					></el-date-picker>
				</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getProjectSimpleList, getLiftSimpleList, getMaintainTypeList, orderPlanSave } from "@/api/MaintenancePlan";
export default {
  data() {
    return {
      form: {
        projectId: "",
        planTime: "",
        liftId: '',
        maintainType: ''
      },
      projectList: [],
      liftList: [],
      maintainTypeList: [],
      rules: {
        projectId: [
          {
            required: true,
            message: "请选择所属项目",
            trigger: "change",
          },
        ],
        liftId: [
          {
            required: true,
            message: "请选择电梯",
            trigger: "change",
          },
        ],
        maintainType: [
          {
            required: true,
            message: "请选择维保类型",
            trigger: "change",
          },
        ],
        planTime: [
          {
            required: true,
            message: "请选择计划时间",
            trigger: "change",
          },
        ],
      },
      loadBtn: false,
    };
  },
  created() {
    this.getMaintainTypeList()
  },
  methods: {
    async getMaintainTypeList() {
      const res = await getMaintainTypeList()
      if (res.code === 200) {
        this.maintainTypeList = res.data
      }
    },
    async searchLiftList(keyword) {
      if (!this.form.projectId) {
        return
      }
      const res = await getLiftSimpleList({
        keyword: keyword,
        size: 100,
        projectId: this.form.projectId
      });
      if (res.code === 200) {
        this.liftList = res.data;
      }
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const res = await orderPlanSave(this.form);
          if (res.code === 200) {
            this.$message.success("添加成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/MaintenancePlan/components/AddPlan.vue